/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APISupplierSearchResult } from './APISupplierSearchResult';
import {
    APISupplierSearchResultFromJSON,
    APISupplierSearchResultFromJSONTyped,
    APISupplierSearchResultToJSON,
} from './APISupplierSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APISupplierSearchResponse
 */
export interface APISupplierSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APISupplierSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APISupplierSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APISupplierSearchResult>}
     * @memberof APISupplierSearchResponse
     */
    results: Array<APISupplierSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APISupplierSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APISupplierSearchResponse interface.
 */
export function instanceOfAPISupplierSearchResponse(value: object): value is APISupplierSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APISupplierSearchResponseFromJSON(json: any): APISupplierSearchResponse {
    return APISupplierSearchResponseFromJSONTyped(json, false);
}

export function APISupplierSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISupplierSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APISupplierSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APISupplierSearchResponseToJSON(value?: APISupplierSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APISupplierSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

